import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

// Yup schema for password change validation
const passwordChangeSchema = yup.object().shape({
  newPassword: yup
    .string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("newPassword"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

const PasswordChangeForm = ({ onSubmit, switchToLogin }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(passwordChangeSchema),
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="auth-form">
      <div className="form-field">
        <input
          type="password"
          placeholder="New Password"
          {...register("newPassword")}
        />
        {errors.newPassword && (
          <p className="error">{errors.newPassword.message}</p>
        )}
      </div>
      <div className="form-field">
        <input
          type="password"
          placeholder="Confirm Password"
          {...register("confirmPassword")}
        />
        {errors.confirmPassword && (
          <p className="error ">{errors.confirmPassword.message}</p>
        )}
      </div>
      <button type="submit" className="submit-button">
        Change Password
      </button>
      <div className="auth-footer">
        <a onClick={switchToLogin} className="login-link">
          Back to Login
        </a>
      </div>
    </form>
  );
};

export default PasswordChangeForm;
